import * as React from 'react';
import '@swc/helpers';
import '@grandvisionhq/utils';
import '../../../../../context/PaymentsUI/context.js';
import '@paypal/react-paypal-js';
import '@grandvisionhq/state';
import '../../../../../models/adyen/payment-type.js';
import '@grandvisionhq/icons';
import '../../../../../models/cart-payment-methods/cart-payment-methods.js';
import '../../../../../models/googlePay/types.js';
import '../../../../../models/payment/types.js';
import '../../../../../models/paypal/context.js';
import { MbwayContainer } from '../../../containers/Adyen/Mbway/containers/MbwayContainer.js';
import '@grandvisionhq/forms';
import { isMbwayDetails } from './types.js';

const Mbway = ({ details , onChange  })=>{
    const initialValue = isMbwayDetails(details) ? details.phoneNumber : '+351';
    return /*#__PURE__*/ React.createElement(MbwayContainer, {
        initialValue: initialValue,
        onChange: onChange
    });
};

export { Mbway };
//# sourceMappingURL=Mbway.js.map
